import { action, observable, computed } from 'mobx'
import { LoginRepository } from './LoginRepository'
import { ControllerStoreBase } from 'src/controllers/ControllerStoreBase'
import { AuthenticationRequest } from './protocols/AuthenticationRequest'
import { PasswordRequest } from './protocols/PasswordRequest'
import { GlobalController } from 'src/shared/global/GlobalController'
import router from 'src/router'
import { omit } from 'lodash'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'

export class LoginController extends ControllerStoreBase {
  @observable email = ''
  @observable password = ''
  newPassword = ''
  passwordConfirmation = ''
  globalController = GlobalController.getInstance()

  static getInstance () {
    return super.construct(new LoginController())
  }

  @action async login () {
    if (this.isValidLoggIn) {
      const authReq = new AuthenticationRequest(this.email, this.password)
      const authResp = await LoginRepository.login(authReq)
      this._storeToken(authResp)
      this._setProfile(authResp)
      try {
        const auth = getAuth()
        const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password)
        const user = userCredential.user
        this._setProfile(userCredential.user)
      } catch (error) {
        console.error(error)
      }
      if (authResp.isRedefinePassword) router.push({ name: 'password' })
      else router.push({ name: 'mainLayout' })
    }
  }

  @action async loginWithGoogle (googleAuthRequest) {
    try {
      const authResp = await LoginRepository.googleAuth(
        omit(googleAuthRequest, 'profile')
      )
      this._storeToken(authResp)
      this._setProfile({ ...googleAuthRequest.profile, source: 'google' })
      router.push({ name: 'mainLayout' })
    } catch (error) {
      console.error('loginWithGoogle:', error)
      throw error
    }
  }

  @action async refreshToken () {
    const authResp = await LoginRepository.refreshToken()
    this._storeToken(authResp)
  }

  @action async createPassword () {
    if (this.isValidPassword) {
      const passwordReq = new PasswordRequest(
        this.newPassword,
        this.passwordConfirmation
      )
      await LoginRepository.password(passwordReq)
      router.push({ name: 'mainLayout' })
    }
  }

  @action logout () {
    this.globalController.setAuthResp(null)
    this.globalController.clearProfile()
    router.push({ name: 'login', params: { reload: true } })
  }

  @computed get isValidLoggIn () {
    return (
      this.email !== null &&
      this.email.length > 0 &&
      this.password !== null &&
      this.password.length > 0
    )
  }

  @computed get isValidPassword () {
    return (
      this.newPassword !== null &&
      this.newPassword.length > 0 &&
      this.passwordConfirmation !== null &&
      this.passwordConfirmation.length > 0 &&
      this.newPassword == this.passwordConfirmation
    )
  }

  _storeToken (authResp) {
    this.globalController.setAuthResp(authResp)
  }

  _setProfile (profile) {
    this.globalController.setProfile(profile)
  }

  getName () {
    return 'LoginController'
  }
}
